// ── Role helpers (shared by App routing + Layout nav) ────────────────────────
// Every admin-panel user (owner AND cashier) logs in with isAdmin:true in the
// JWT, so isAdmin alone can't tell them apart — the real role is payload.role.
// Read role FIRST; only fall back to isAdmin for legacy tokens with no role
// claim (those belong to the owner, created before roles existed).
export const getMyRole = () => {
  try {
    const token = localStorage.getItem('adminToken');
    if (!token) return 'cashier';
    const payload = JSON.parse(atob(token.split('.')[1]));
    const role = payload.role;
    if (role === 'cashier')  return 'cashier';
    if (role === 'delivery') return 'delivery';
    if (role === 'admin')    return 'admin';
    return payload.isAdmin ? 'admin' : 'cashier'; // legacy token → owner
  } catch { return 'cashier'; }
};

export const isAdmin   = () => getMyRole() === 'admin';
export const isCashier = () => getMyRole() !== 'admin';

// The only pages a cashier may open. Everything else is owner/admin only.
// Keep in sync with the backend requireAdmin guards.
export const CASHIER_PATHS = ['/billing', '/orders', '/returns', '/purchases'];
export const cashierCanAccess = (path) => CASHIER_PATHS.includes(path);
